import styled from "styled-components";

export const CommentHeader = styled.h3`
  height: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 0;
  padding-bottom: 0;
  opacity: 1;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: 0.24em;
  text-align: justify;
  vertical-align: middle;
  text-transform: uppercase;
  color: #3D3D3D;
`;
